import cn from '../config/locale/cn'
import en from '../config/locale/en'
import tw from '../config/locale/tw'

export default {
    namespace: 'locale',
    state: {
        LOCALE_SYSTEM: {},
        LOCALE_HTML: {},
    },
    reducers: {
        update(state, { payload: { locale } }) {
            switch (locale) {
                case 'en':
                    return { LOCALE_SYSTEM: en.LOCALE_SYSTEM, LOCALE_HTML: en.LOCALE_HTML }
                case 'tw':
                    return { LOCALE_SYSTEM: tw.LOCALE_SYSTEM, LOCALE_HTML: tw.LOCALE_HTML }
                default:
                    return { LOCALE_SYSTEM: cn.LOCALE_SYSTEM, LOCALE_HTML: cn.LOCALE_HTML }
            }
        },
    }
}